<template>
  <div class="animated revealUp">

    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $t("autoemailreport") }}
      </div>
      <div>
        <router-link
          class="btn-blue"
          to="auto-emailer-v2"
        >{{ $t("autoemailreport") }} {{ $tc("list", 1) }}
        </router-link
        >
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="
                  AutoEmailReportData.selectedcinema &&
                  AutoEmailReportData.selectedcinema.length > 0
                    ? 'shift-up'
                    : ''
                "
              >Select Cinema</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="AutoEmailReportData.selectedcinema"
                class="w-100"
                variant="dropdown-curve"
              >
                <div class="px-2 pb-2">
                  <input
                    v-model="searchCinema"
                    autofocus
                    class="form-control form-control-sm"
                    placeholder="Search Cinema"
                    required
                    type="search"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in Cinemas.filter(r => {
                    if (!this.searchCinema || this.searchCinema.length === 0 ) return true
                    else return String(r.cine_name).toLowerCase().includes(String(this.searchCinema).toLowerCase())
                  })"
                  :key="CinemaIndex"
                  href="#"
                  v-on:click="OnSelectDropDown(Cinema, 'Cinema')"
                >{{ Cinema.cine_name }}
                </b-dropdown-item
                >
              </b-dropdown>
            </div>

            <Tooltip :title="$t('select_cinema_report')"/>
          </div>
          <p class="error_message">
            <span
              v-if="submitted && AutoEmailReportData.selectedcinema.length == 0"
            >Please Select Cinema.</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                AutoEmailReportData.reportname &&
                AutoEmailReportData.reportname.length > 0
                  ? 'shift-up'
                  : ''
              "
            >{{ $t("select") }} {{ $t("report") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="AutoEmailReportData.reportname"
                class="w-100"
                variant="dropdown-curve"
              >
                <div class="px-2 pb-2">
                  <input
                    v-model="searchReport"
                    autofocus
                    class="form-control form-control-sm"
                    placeholder="Search Report"
                    required
                    type="search"
                  />
                </div>
                <b-dropdown-item
                  v-for="(report, reportIndex) in report_types.filter(r => {
                    if (!this.searchReport || this.searchReport.length === 0 ) return true
                    else return String(r.name).toLowerCase().includes(String(this.searchReport).toLowerCase())
                  })"
                  :key="reportIndex"
                  @click="OnSelectDropDown(report, 'Report')"
                >{{ report.name }}
                </b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('select_report')"/>
            </div>
            <p class="error_message">
              <span
                v-if="submitted && AutoEmailReportData.reportname.length == 0"
              >Please Select Report</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <multiselect
              v-model="selectedScreens"
              v-b-tooltip.hover
              :disabled="!(AutoEmailReportData.report_type == 2)"
              :multiple="true"
              :options="Screens"
              label="screen_name"
              placeholder="Select Screens"
              title="Select Screens"
              track-by="screen_id"
            >
              <span slot="noResult">
                No results found.
              </span>
            </multiselect>
          </div>
          <p class="error_message">
            <span v-if="false && submitted && selectedScreens.length == 0">Please Select Screen.</span>
          </p>
        </div>

        <div class="col-lg-12 align-self-center mb-4">
          <div class="row">
            <div class="col-lg-5 col-xl-3 align-self-center mb-4">
              <div class="row">
                <div class="col-md-6 col-xl-6">
                  <label>{{ "Previous Cycle" }}</label>
                </div>
                <div class="col-md-6 col-xl-6">
                  <div class="col-4">
                    <b-form-checkbox
                      v-model="is_previous_cycle"
                      name="check-button"
                      switch
                      unchecked-value="N"
                      value="Y"
                    ></b-form-checkbox>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-2 col-xl-2">
              <div>{{ $t("frequency") }} :</div>
            </div>
            <div class="col pl-0">
              <div class="row">
                <b-form-checkbox
                  v-model="frequencyDaily"
                  class="j-checkbox mb-1"
                  style="min-width: 100px"
                  @change="OnSelectfrequency($event, 'Daily')"
                >
                  <div class="text-capitalize">Daily</div>
                </b-form-checkbox>

                <span>OR</span>

                <b-form-checkbox
                  v-model="frequencySelectedDays"
                  class="j-checkbox mb-3 ml-5"
                  style="min-width: 125px"
                  @change="OnSelectfrequency($event, 'WeekDays')"
                >
                  <div class="text-capitalize">Weekly</div>
                </b-form-checkbox>

                <span>OR</span>

                <b-form-checkbox
                  v-model="frequencyMonthly"
                  class="j-checkbox mb-3 ml-5"
                  style="min-width: 125px"
                  @change="OnSelectfrequency($event, 'Monthly')"
                >
                  <div class="text-capitalize">Monthly</div>
                </b-form-checkbox>
              </div>
            </div>
            <p class="error_message">
              <span
                v-if="
                  submitted &&
                  frequencyDaily === false &&
                  frequencySelectedDays === false &&
                  frequencyMonthly === false
                "
              >Please at least One Frequency.</span
              >
            </p>
          </div>
        </div>

        <div v-if="frequencySelectedDays" class="col-lg-12 align-self-center mb-4">
          <div class="row">
            <div class="col-lg-3 col-xl-1">
              <div>{{ $t("select") }} {{ $t("day") }} :</div>
            </div>
            <div class="col-lg-9 col-xl-10 pl-0">
              <div class="row">
                <b-form-checkbox
                  v-for="(weekdaysLoop, weekdaysKey) in weekDays"
                  :key="weekdaysKey"
                  v-model="weekDays[weekdaysKey]"
                  class="j-checkbox mb-3"
                  style="min-width: 125px"
                  unchecked-value="N"
                  value="Y"
                  @change="OnSelectWeekends($event, weekdaysKey)"
                >
                  <div class="text-capitalize">{{ weekdaysKey }}</div>
                </b-form-checkbox>
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted" class="ml-3">{{ msgweek }}</span>
            </p>
          </div>
        </div>

        <div v-if="frequencyMonthly" class="col-lg-12 align-self-center mb-4">
          <div class="row">
            <div class="col-lg-3 col-xl-1">
              <div>{{ "On day of the month" }} :</div>
            </div>
            <div class="col-lg-9 col-xl-10 pl-0">
              <div class="row">
                <b-dropdown
                  id="date_of_month"
                  :text="date_of_month"
                  class="w-100 text-center mr-3 col-2"
                  name="date_of_month"
                  variant="dropdown-curve"
                >
                  <b-dropdown-item
                    v-for="(date, index) in Array.from({length: 31}, (_, i) => i + 1).map(x => String(x))"
                    :key="index"
                    href="#"
                    v-on:click="date_of_month = date"
                  >{{ date }}
                  </b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>
            <p class="error_message">
            </p>
          </div>
        </div>

        <div class="col-lg-12 align-self-center mb-4">
          <div class="row">
            <section class="mb-2 w-100 px-3 distributor-section-new">
              <div
                v-b-toggle.personSection
                class="section-title mb-3 d-flex justify-content-between section-border section-border"
                style="padding:6px;align-items:center"
              >
              <span class="fs">
                {{ $t("add") }} {{ $t("email") }}
              </span>
                <button class="btn-transparent chevron" type="button">
                  <img
                    height="24"
                    src="@/assets/img/icons/primary/chevron-down.svg"
                    width="24"
                  />
                </button>
              </div>
              <b-collapse
                id="personSection"
                v-model="sectionCollapse.personSection"
                class="mt-2"
              >
                <div v-if="persons.length > 0">
                  <div class="row border mx-0 rounded mb-2">
                    <div
                      class="col-12 pl-0 movie-version-box"
                      style="padding-top:26px;padding-bottom:0px;padding-right:0px"
                    >
                      <div
                        v-for="(person, index) in persons"
                        :key="index"
                        class="col-12 px-1"
                      >
                        <div
                          class="row w-100 px-0 m-0 justify-content-around align-items-center"
                        >
                          <div
                            class="col-lg-6 col-xl-2 px-1 align-self-center mb-2"
                          >
                            <div class="d-flex align-items-center">
                              <div class="input-material">
                                <input
                                  v-model="person.name"
                                  v-b-tooltip.hover
                                  :title="$t('Full Name')"
                                  placeholder="Name"
                                  type="text"
                                />
                                <label>{{ $t("Name") }}</label>
                              </div>
                              <!--Tooltip :title="$t('Full Name')" /-->
                            </div>
                            <p class="error_message">
                            <span
                              v-if="person.submit && person.name.length == 0"
                            >Please enter the name</span
                            >
                            </p>
                          </div>
                          <div
                            class="col-lg-6 col-xl-2 px-1 align-self-center mb-2"
                          >
                            <div class="d-flex align-items-center">
                              <div class="input-material">
                                <input
                                  v-model="person.functionType"
                                  v-b-tooltip.hover
                                  :title="$t('Employer Functioning')"
                                  placeholder="Function"
                                  type="text"
                                />
                                <label>{{ $t("Function") }}</label>
                              </div>
                            </div>
                            <p class="error_message">
                            </p>
                          </div>
                          <div
                            class="col-lg-6 col-xl-3 px-1 align-self-center mb-2"
                          >
                            <div class="d-flex align-items-center">
                              <div class="input-material">
                                <input
                                  v-model="persons[index].email"
                                  v-b-tooltip.hover
                                  :title="$t('Employer EmailId')"
                                  placeholder="Email"
                                  type="email"
                                />
                                <label>{{ $t("Email Address") }}</label>
                              </div>
                            </div>
                            <p class="error_message">
                            <span
                              v-if="
                                (persons[index].submit && persons[index].email.length == 0) ||
                                (persons[index].submit && !persons[index].validEmail)
                              "
                            >Please enter Email Address</span>
                            </p>
                          </div>

                          <div
                            class="col-lg-6 col-xl-3 px-1 align-self-center mb-2"
                          >
                            <div class="d-flex align-items-center">
                              <div
                                class="input-material d-flex align-items-center"
                              >
                                <div class="col-5 pl-0">
                                  <b-dropdown
                                    id="toemail"
                                    :text="
                                      person.to
                                        ? person.to
                                        : 'TO/CC/BCC'
                                    "
                                    class="w-100 text-center mr-3"
                                    name="toemail"
                                    variant="dropdown-curve"
                                  >
                                    <b-dropdown-item
                                      v-for="(to, index) in email_to.filter(e => {
                                        if (index == 0) return true
                                        else return e !== 'TO'
                                      })"
                                      :key="index"
                                      href="#"
                                      v-on:click="person.to = to"
                                    >{{ to }}
                                    </b-dropdown-item
                                    >
                                  </b-dropdown>
                                </div>
                              </div>
                            </div>
                            <p class="error_message">
                            </p>
                          </div>

                          <div
                            class="col-lg-6 col-xl-1 px-1 justify-self-center align-self-center mb-2"
                          >
                            <!-- <div class="d-flex align-items-center"> -->
                            <button
                              class="btn-transparent"
                              @click.prevent.stop="removePeople($event, index)"
                            >
                              <img
                                height="35"
                                src="@/assets/img/icons/minus.svg"
                                width="35"
                              />
                            </button>
                            <!-- </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="row w-100 pl-5">
                    <p class="mx-auto mb-0" style="font-weight:600;color:black">
                      Add Email
                    </p>
                  </div>
                </div>
                <div
                  class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                >
                  <button
                    class="btn-transparent add-more-button"
                    @click.prevent.stop="addPeople($event)"
                  >
                    <img
                      height="35"
                      src="@/assets/img/icons/plus.svg"
                      width="35"
                    />
                  </button>
                </div>
              </b-collapse>
            </section>
          </div>
        </div>

        <div class="col-lg-12 align-self-center mb-4">
          <div class="row">
            <section class="my-3 w-100 px-3 distributor-section-new">
              <div
                v-b-toggle.transalations
                class="section-title d-flex justify-content-between section-border section-border"
                style="padding:6px;align-items:center"
              >
              <span class="fs">
                {{ 'Email To Send' }}
              </span>
                <button class="btn-transparent chevron" type="button">
                  <img
                    height="24"
                    src="@/assets/img/icons/primary/chevron-down.svg"
                    width="24"
                  />
                </button>
              </div>
              <b-collapse
                id="transalations"
                v-model="sectionCollapse.transalations"
                class="mt-2 translationContainer"
              >
                <div class="bn-tabs-nav">
                  <span class="editBtn">

                  <button
                    class="btn btn-sm btn-primary"
                    @click="
                      isEdit = !isEdit;
                      isEditHtml = false;
                    "
                  >
                    <img
                      v-if="!isEdit"
                      class="mr-1"
                      height="15"
                      src="@/assets/img/icons/edit-pen-white.svg"
                      width="15"
                    />{{ isEdit ? "Save Text" : "Edit Text" }}
                  </button>
                  <button
                    class="btn btn-sm btn-primary"
                    @click="
                      isEditHtml = !isEditHtml;
                      isEdit = false;
                    "
                  >
                    <img
                      v-if="!isEditHtml"
                      class="mr-1"
                      height="15"
                      src="@/assets/img/icons/edit-pen-white.svg"
                      width="15"
                    />{{ isEditHtml ? "Save HTML" : "Edit HTML" }}
                  </button>
                  </span>
                </div>

                <div class="bn-tabs-content p-3">
                  <div class="row pt-4">

                    <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            id="subject"
                            v-model="subject"
                            v-validate="'required'"
                            maxlength="100"
                            name="subject"
                            placeholder="."
                            @input="onChangeTranslationInput($event)"
                          />
                          <label
                            :class="
                    subject ? 'shift-up' : ''
                  "
                          >{{ "Email Subject" }}
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-12 align-self-center mb-4">
                      <div class="descriptionSection font-weight-bold fs-14 mb-3">Description</div>
                      <div v-if="isEdit" class="">
                        <vue-editor
                          id="page"
                          v-model="body"
                          name="page"
                        ></vue-editor>
                      </div>
                      <div
                        v-else-if="isEditHtml && !isEdit"
                        class="input-material-textarea"
                      >
                  <textarea
                    id="htmlContent"
                    v-model="body"
                    class="htmlContent"
                    name="htmlContent"
                    placeholder="Page Content"
                    @input="onChangeTranslationInput($event)"
                  />
                      </div>
                      <div v-else class="ql-snow">
                        <div
                          v-if="body"
                          class="ql-editor"
                          v-html="body"
                        ></div>
                        <div v-else class="ql-editor text-center" style="min-height:33px;">No Content</div>
                      </div>
                      <vue-editor style="display:none"/>
                    </div>
                  </div>
                </div>

              </b-collapse>
            </section>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  v-model="AutoEmailReportData.is_active"
                  name="check-button"
                  switch
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>


        <div class="col-md-12 text-center mt-4">
          <button class="btn-blue" @click.prevent.stop="OnFinalSubmit()">
            {{ $t("save") }}
          </button>
          <b-button
            class="btn-outline-grey"
            to="auto-email-report"
            variant="default"
          >{{ $t("cancel") }}
          </b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import moment from "moment";
import {VueEditor} from "vue2-editor";
import _ from "lodash";

export default {
  components: {DatePicker, VueTimepicker, VueEditor},
  data() {
    return {
      body: '',
      subject: '',
      emailreoprtList: [],
      date_of_month: 1,
      is_previous_cycle: 'Y',
      sectionCollapse: {
        personSection: true,
        transalations: true,
      },
      editCode: false,
      isEdit: true,
      isEditHtml: false,
      langContent: [],
      Languages: [],
      ContentLanguages: [],
      activeClass: 0,
      notempty: [false, false, false, false, false, false],
      email_content: {
        subject: "",
        body: "",
      },
      persons: [],
      email_to: [
        'TO',
        'CC',
        'BCC',
      ],
      report_types: [
        {
          report_type: 1,
          name: 'Distributor Summary Report',
        },
        {
          report_type: 2,
          name: 'Aggregator Sales Report',
        },
        {
          report_type: 3,
          name: 'Summary & Performance Report',
        },
      ],
      frequency_type: [
        {
          frequency_type: 1,
          name: 'Daily',
        },
        {
          frequency_type: 2,
          name: 'Weekly',
        },
        {
          frequency_type: 3,
          name: 'Monthly',
        },
      ],
      Screens: [],
      selectedScreens: [],
      ScreensCopy: [],
      ReportsCopy: [],
      searchReport: "",
      UsersCopy: [],
      searchUser: "",
      DistributorsCopy: [],
      searchDistributor: "",
      CinemasCopy: [],
      searchCinema: "",
      btenable: false,
      isRoleID: true,
      show: true,
      showDistributor_and_Movie: false,
      submitted: false,
      Cinemas: [],
      Users: [],
      Reports: [],
      Distributors: [],
      DistributorsMovies: [],
      frequencyDaily: true,
      frequencySelectedDays: false,
      frequencyMonthly: false,
      selectedCinema: null,
      selectedReport: null,
      weekDays: {
        sunday: 'N',
        monday: 'Y',
        tuesday: 'N',
        wednesday: 'N',
        thursday: 'N',
        friday: 'N',
        saturday: 'N',
      },
      AutoEmailReportData: {
        selectedScreensString: '',
        userfullname: "",
        reportname: "",
        selectedcinema: "",
        distributorname: "",
        moviename: "",
        movie_id: null,
        d_id: null,
        cine_id: null,
        user_id: null,
        report_type: null,
        datetime: null,
        is_active: "Y",
      },
      msgweek: "",
      CinemaReports: [
        "Summary Report",
        "Performance Report",
        "Daily Sales Report",
        "Distributor Collection Report",
        "COGS Report",
        "Stock Wastage Report",
        "Municipality Report",
        "Advance Booking Report",
      ],
      startTime2: ""
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }

    this.getCinemasList(obj);
  },
  methods: {
    CheckEmptyContent: function (content, langIndex) {
    },
    onChangeInput(event, item) {
    },
    onChangeTranslationInput(event, content, contentIndex, item) {
    },
    onChangeTabHandler: function (event, index) {
    },
    validateEmail: function (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    addPeople() {
      this.persons.push({
        name: "",
        functionType: "",
        email: "",
        to: this.persons.length ? "CC" : "TO",
        submit: false,
      });
    },
    removePeople(event, index) {
      this.persons.splice(index, 1)
      this.$forceUpdate()

      if (this.persons.length == 1) {
        this.persons[0].to = 'TO'
      }
      if (this.persons.length > 1) {
        let isTOpresent = this.persons.some(p => p.to == 'TO')
        if (!isTOpresent) {
          this.persons[0].to = 'TO'
        }
      }
      this.$forceUpdate()
    },
    getCinemasList: function (cine_id) {
      let loader = this.$loading.show();

      this.searchReport = ""
      this.searchCinema = ""
      this.Cinemas = [];
      this.Screens = [];
      this.selectedScreens = []
      this.ScreensCopy = [];

      MasterService.GetCinemas({cine_id: cine_id})
      .then((response) => {
        const {data} = response;
        if (data && data.status && data.Records.length > 0) {
          this.Cinemas = data.Records;
          this.CinemasCopy = data.Records;
          this.Cinemas.map((x) => {
            if (String(cine_id) === String(x.cine_id)) {
              this.AutoEmailReportData.selectedcinema = x.cine_name;
              this.AutoEmailReportData.cine_id = x.cine_id;
            }
          });
        } else {
          this.$toasted.show(data.message);
        }
      })
      .then(() => {
        if (this.$route.params.am_id) {
          this.GetAllAutoEmailReport('Y', this.$route.params.am_id);
        }
      })
      .catch(this._CatchError)
      .finally(() => {
        loader.hide()
      });
    },

    OnSelectDropDown: function (data, type) {
      if (type === "Report") {
        this.selectedScreens = []
        this.selectedReport = data
        this.AutoEmailReportData.reportname = data.name;
        this.AutoEmailReportData.report_type = data.report_type;
        this.searchReport = "";
      }
      if (type === "Cinema") {
        this.selectedScreens = []
        this.Screens = [];
        this.ScreensCopy = [];
        this.AutoEmailReportData.selectedcinema = data.cine_name;
        this.AutoEmailReportData.cine_id = data.cine_id;
        this.searchCinema = "";

        this.selectedCinema = data.cine_name;
        this.selectedid = {
          cine_id: data.cine_id
        };
        this.getScreensList(data);
        this.$store.dispatch("selectDropdownCinema", data);
      }
    },
    OnSelectfrequency: function (event, frequency) {
      if (frequency === "Daily") {
        this.frequencyDaily = true;
        this.frequencySelectedDays = false;
        this.frequencyMonthly = false;

        this.weekDays = {
          sunday: 'Y',
          monday: 'Y',
          tuesday: 'Y',
          wednesday: 'Y',
          thursday: 'Y',
          friday: 'Y',
          saturday: 'Y',
        };
      }

      if (frequency == 'WeekDays') {
        this.weekDays = {
          sunday: 'N',
          monday: 'Y',
          tuesday: 'N',
          wednesday: 'N',
          thursday: 'N',
          friday: 'N',
          saturday: 'N',
        };

        this.frequencyDaily = false;
        this.frequencySelectedDays = true;
        this.frequencyMonthly = false;
      }

      if (frequency == 'Monthly') {
        this.weekDays = {
          sunday: 'N',
          monday: 'N',
          tuesday: 'N',
          wednesday: 'N',
          thursday: 'N',
          friday: 'N',
          saturday: 'N',
        };

        this.frequencyDaily = false;
        this.frequencySelectedDays = false;
        this.frequencyMonthly = true;

      }

      this.$forceUpdate()
    },
    OnSelectWeekends: function (event, days) {
      Object.keys(this.weekDays)
      .forEach(d => {
        if (d != days) {
          this.weekDays[d] = 'N'
        }
      })

      this.msgweek = "";
    },
    convertTime(date, time) {
      const d = moment(date).format("YYYY-MM-DD");
      const newdate = moment(d + " " + time).format('YYYY-MM-DD HH:mm');
      return newdate
    },
    getScreensList: function (item) {
      let loader = this.$loading.show();

      this.selectedScreens = []
      this.Screens = [];
      this.ScreensCopy = [];
      let body = {
        tableName: "screens",
        activekey: "screen_is_active",
        conditionColName: "cinema_id",
        conditionId: item.cine_id,
        limit: 1000,
        currentPage: 1,
        searchValue: '',
        searchKey: '',
        columnName: 'screen_order',
        orderBy: 'asc',
      };

      CinemasService.GetActiveScreenByCinema(body)
      .then(response => {
        const {data} = response;
        if (data && data.status) {
          this.Screens = data.Records;
          this.ScreensCopy = data.Records;

          if (this.AutoEmailReportData.selectedScreensString && this.AutoEmailReportData.selectedScreensString.length) {
            let screen_ids = this.AutoEmailReportData.selectedScreensString.split(',')
            this.selectedScreens = data.Records.filter(s => {
              return screen_ids.includes(String(s.screen_id))
            })
          }
        } else {
          this.$toasted.show(data.message);
        }
      })
      .catch(this._CatchError)
      .finally(() => {
        loader.hide()
      })
    },

    OnFinalSubmit() {
      console.log({
        "OnFinalSubmit_am_id": this.$route.params.am_id,
      })

      this.submitted = true;
      this.persons.forEach(item => {
        item.email = String(item.email).trim()
        item.submit = true;
      });
      for (const item of this.persons) {
        if (this.validateEmail(item.email) == false) {
          item.validEmail = false
          this.$toasted.show("Email id is incorrect");
          return;
        } else {
          item.validEmail = true
        }
      }

      if (
        this.AutoEmailReportData.report_type == null &&
        this.AutoEmailReportData.reportname.length == 0
      ) {
        // this.$toasted.show('Please Select Report')
        return;
      }
      if (
        this.AutoEmailReportData.selectedcinema.length == 0 &&
        this.AutoEmailReportData.cine_id == null
      ) {
        // this.$toasted.show('Please Select Cinema')
        return;
      }
      if (
        this.frequencyDaily === false &&
        this.frequencySelectedDays === false &&
        this.frequencyMonthly === false
      ) {
        this.$toasted.show('Please Select Frequency')
        return;
      }
      if (this.persons.length === 0) {
        this.$toasted.show('No email added')
        return;
      }

      if (
        this.AutoEmailReportData.report_type == 2 &&
        this.selectedScreens.length == 0
      ) {
        this.$toasted.show('Please Select least one Screen')
        return;
      }
      if (this.AutoEmailReportData.report_type != 2) {
        this.selectedScreens = []
      }

      this.btenable = true;
      let loader = this.$loading.show();
      this.AutoEmailReportData.datetime = this.convertTime(this.AutoEmailReportData.datetime, this.startTime2)
      let payload = {
        is_active: this.AutoEmailReportData.is_active,
        cinema_id: this.getSafe(() => this.AutoEmailReportData.cine_id, 0),
        screen_id: this.getSafe(
          () => this.selectedScreens.map(s => s.screen_id).map(x => String(x).trim()).filter(x => x).join(','), ''
        ),
        report_type: this.getSafe(() => this.selectedReport.report_type, 1),
        frequency_type:
          this.frequencyMonthly
            ? 3
            : this.frequencySelectedDays
              ? 2
              : 1,
        frequency_rules: JSON.stringify(this.frequency_rules || {}),
        emails: JSON.stringify(this.persons),
        body: this.body || 'AutoEmailReportData',
        subject: String(this.subject || 'Report Email').replace(/(\r\n|\n|\r)/gm, " ").trim(),

        date_of_month: this.date_of_month,
        is_previous_cycle: this.is_previous_cycle,

        is_sunday: this.weekDays.sunday,
        is_monday: this.weekDays.monday,
        is_tuesday: this.weekDays.tuesday,
        is_wednesday: this.weekDays.wednesday,
        is_thursday: this.weekDays.thursday,
        is_friday: this.weekDays.friday,
        is_saturday: this.weekDays.saturday,
      };

      if (this.$route.params.am_id) {
        payload.am_id = this.$route.params.am_id;
      }

      console.log({
        payload,
        "am_id": this.$route.params.am_id,
      })

      MasterService.AddAutoEmailReportV2(payload)
      .then((response) => {
        this.btenable = false;
        const {data} = response;

        if (data.status) {
          this.$toasted.show(data.message);

          this.$router.push({
            path: "/master/auto-emailer-v2",
          });
        } else {
          this.$toasted.show(data.message);
        }
      })
      .catch(this._CatchError)
      .finally(() => {
        setTimeout(() => loader.hide(), 100);
      });
    },

    GetAllAutoEmailReport: function (filter_is_active = 'Y', am_id) {
      let loader = this.$loading.show();

      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        am_id,
      }

      MasterService.GetAutoEmailReportV2(body).then(response => {
        const {data} = response

        if (data.status) {
          if (data.Records && data.Records.data && data.Records.data.length > 0) {
            this.emailreoprtList = data.Records.data[0]

            if (this.emailreoprtList) {

              this.OnSelectfrequency(
                {},
                this.emailreoprtList.frequency_type == 3
                  ? "Monthly"
                  : this.emailreoprtList.frequency_type == 2
                    ? "WeekDays"
                    : "Daily"
              )

              this.body = _.unescape(this.emailreoprtList.body)
              this.subject = this.emailreoprtList.subject
              this.persons = JSON.parse(this.emailreoprtList.emails)

              this.is_previous_cycle = this.emailreoprtList.is_previous_cycle
              this.is_active = this.emailreoprtList.is_active
              this.AutoEmailReportData.is_active = this.emailreoprtList.is_active
              this.AutoEmailReportData.selectedScreensString =
                String(this.emailreoprtList.screen_id)
                .split(',')
                .map(x => String(x).trim())
                .filter(x => x)
                .filter(x => x != '0')
                .join(',')

              this.weekDays.sunday = this.emailreoprtList.is_sunday
              this.weekDays.monday = this.emailreoprtList.is_monday
              this.weekDays.tuesday = this.emailreoprtList.is_tuesday
              this.weekDays.wednesday = this.emailreoprtList.is_wednesday
              this.weekDays.thursday = this.emailreoprtList.is_thursday
              this.weekDays.friday = this.emailreoprtList.is_friday
              this.weekDays.saturday = this.emailreoprtList.is_saturday

              this.date_of_month = this.emailreoprtList.date_of_month

              let selectedReport = this.report_types.filter(x => x.report_type == this.emailreoprtList.report_type)
              if (selectedReport.length > 0) {
                this.OnSelectDropDown(selectedReport[0], 'Report')
              }

              let selectedCinema = this.Cinemas.filter(x => x.cine_id == this.emailreoprtList.cinema_id)
              if (selectedCinema.length > 0) {
                this.OnSelectDropDown(selectedCinema[0], 'Cinema')
              }
            }
          }
        }
      })
      .finally(() => {
        loader.hide()
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/AutoEmailerV2/addautoemailreport.vue